import { Fragment } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";

const Hero = () => {
    return (
        <Fragment>
            <header className={clsx(
                "w-full max-w-[1440px] mx-auto relative top-8 tablet:top-[3.1rem]",
                "px-6 tablet:px-8 desktop:px-[120px]",
                "tablet:pb-[40px] tablet:mb-16 pb-[139px] phone:pb-12 phone:mb-8"
            )}>
                <div className={clsx(
                    "w-full flex flex-col items-center",
                    "tablet:max-w-[614px] desktop:max-w-[751px] mx-auto",
                    "pt-10 tablet:pt-16 desktop:pt-[110px]"
                )}>
                    <h1 className="text-heading-1 tablet:text-heading-2 text-center phone:text-heading-3 desktop:text-display font-semibold text-basier-circle-semibold text-neutral-100">Start Selling in Minutes</h1>
                    <p className="text-neutral-50 text-center font-normal tablet:text-lg desktop:text-lg text-lg tracking-text leading-[30.6px] pt-4 md:text-center">
                        Make Some Extra Dollars for Gushing About Our Proxy Service.
                        Work with us and earn up to $2,000 for every customer you bring to Anonymous Proxies!
                    </p>
                    <div className="w-full flex flex-col md:flex-row md:items-center justify-center md:space-x-6 space-y-4 md:space-y-0 mt-10 tablet:mt-8 phone:mt-8">
                        <button className="relative z-20 py-[18px] w-full md:w-fit px-[20px] h-[56px] font-semibold leading-[19.83px] rounded-lg bg-primary-main hover:bg-primary-hover text-md text-basier-circle-semibold text-neutral-10">Become an Affiliate</button>
                        <button className="py-[18px] w-full md:w-fit leading-[19.83px] px-[30px] font-semibold rounded-lg text-primary-main h-[56px] text-md text-basier-circle-semibold bg-primary-surface">Affiliate Login</button>
                    </div>
                </div>
                <div className="w-full flex item-center justify-center phone:mt-12 tablet:mt-[56px] mt-[177px]">
                    <img className='w-[787px] h-[488px] tablet:h-[398px] phone:h-[203px] tablet:max-w-[642px]' src="/images/affiliates/hero.png" alt="hero" />
                </div>
            </header>
        </Fragment>
    );
};

export default Hero;